module.exports = __webpack_public_path__ + "img/running-clock-alert-outline.6b499321.svg";